import React, { useState } from 'react';
import { authAPI } from '../services/api';

function Login({ onLogin }) {
  const [loginMode, setLoginMode] = useState('jwt'); // 'jwt' or 'apikey'
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [apiKey, setApiKey] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  // Legacy API key (for backward compatibility)
  const CORRECT_API_KEY = 'Puraxel-by-LaMeditech!';

  const handleJWTLogin = async (e) => {
    e.preventDefault();
    setError('');
    
    if (!username.trim() || !password.trim()) {
      setError('Please enter username and password');
      return;
    }

    setLoading(true);

    try {
      const response = await authAPI.login(username, password);
      const { access_token, refresh_token, user, permissions } = response.data;
      
      // Store tokens
      localStorage.setItem('accessToken', access_token);
      localStorage.setItem('refreshToken', refresh_token);
      localStorage.setItem('currentUser', JSON.stringify(user));
      localStorage.setItem('permissions', JSON.stringify(permissions));
      
      // Check if password change is required
      if (user.must_change_password) {
        onLogin({ 
          type: 'jwt', 
          user, 
          permissions,
          mustChangePassword: true 
        });
      } else {
        onLogin({ 
          type: 'jwt', 
          user, 
          permissions,
          mustChangePassword: false 
        });
      }
    } catch (error) {
      const message = error.response?.data?.detail || 'Login failed. Please check your credentials.';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  const handleAPIKeyLogin = (e) => {
    e.preventDefault();
    setError('');
    
    if (!apiKey.trim()) {
      setError('Please enter an API key');
      return;
    }
    
    if (apiKey !== CORRECT_API_KEY) {
      setError('Invalid API key. Please check and try again.');
      setApiKey('');
      return;
    }
    
    localStorage.setItem('apiKey', apiKey);
    onLogin({ type: 'apikey' });
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>Puraxel Backoffice</h2>
        <p style={{ textAlign: 'center', color: '#7f8c8d', marginBottom: '20px' }}>
          Administrator Login
        </p>

        {/* Login Mode Tabs */}
        <div className="login-tabs">
          <button 
            className={`login-tab ${loginMode === 'jwt' ? 'active' : ''}`}
            onClick={() => { setLoginMode('jwt'); setError(''); }}
            type="button"
          >
            👤 Admin Login
          </button>
          <button 
            className={`login-tab ${loginMode === 'apikey' ? 'active' : ''}`}
            onClick={() => { setLoginMode('apikey'); setError(''); }}
            type="button"
          >
            🔑 API Key
          </button>
        </div>

        {error && <div className="error">{error}</div>}

        {loginMode === 'jwt' ? (
          <form onSubmit={handleJWTLogin}>
            <div className="form-group">
              <label>Username</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter your username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoComplete="username"
                disabled={loading}
              />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                className="form-control"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                disabled={loading}
              />
            </div>
            <button 
              type="submit" 
              className="btn btn-primary" 
              style={{ width: '100%' }}
              disabled={loading}
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
        ) : (
          <form onSubmit={handleAPIKeyLogin}>
            <div className="form-group">
              <label>API Key</label>
              <input
                type="password"
                className="form-control"
                placeholder="Enter your API key"
                value={apiKey}
                onChange={(e) => setApiKey(e.target.value)}
                autoComplete="off"
              />
            </div>
            <button type="submit" className="btn btn-primary" style={{ width: '100%' }}>
              Login with API Key
            </button>
          </form>
        )}

        <p style={{ marginTop: '20px', textAlign: 'center', color: '#95a5a6', fontSize: '12px' }}>
          {loginMode === 'jwt' 
            ? 'Use your admin account credentials' 
            : 'Legacy API key authentication'}
        </p>
      </div>
    </div>
  );
}

export default Login;